export default __webpack_public_path__ + "static/media/than_chi.50b4d30b.jpg";